import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss']
})
export class VideoModalComponent implements OnInit {

  @Input() modalTitle = "Modal";
  @Input() videoUrl?: "/assets/videos/ReportsFeed - Microsoft Azure EN.webm" | "/assets/videos/ReportsFeed - Microsoft Azure PT.webm";
  @Input() videoWidth = null;
  @Input() videoHeight = null;
  @Input() autoplay = true;
  @Input() hasCloseButtonAtHeader = true;
  @Input() hasCloseButtonAtBody = true;

  public errorMessage?: string;

  @ViewChild('videoElement', { static: false }) videoElement: ElementRef;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    setTimeout(this.attachVideo.bind(this), 100);
  }

  attachVideo() {
    if (!this.videoElement) {
      console.warn("ViewChild for video was not populated");
      return;
    }
    if (!this.videoElement.nativeElement) {
      console.warn("ViewChild for video did not contain video");
    }
    if (this.autoplay) {
      this.videoElement.nativeElement.setAttribute("autoplay", "true");
    }
    const f = this.onVideoError.bind(this);
    this.videoElement.nativeElement.onerror = f;
    this.videoElement.nativeElement.addEventListener("error", f);

    // Check if video size is supposed to be automatic
    if (this.videoWidth === null && this.videoElement.nativeElement.hasAttribute("width")) {
      this.videoElement.nativeElement.removeAttribute("width");
    }
    if (this.videoHeight === null && this.videoElement.nativeElement.hasAttribute("height")) {
      this.videoElement.nativeElement.removeAttribute("height");
    }

    // This sends the browser request for the video
    this.videoElement.nativeElement.src = this.videoUrl;
    // Do not directly set this in angular or the error callback will not be called
  }

  onVideoError(event) {
    let error = event;

    // Chrome v60
    if (event.path && event.path[0]) {
      error = event.path[0].error;
    }

    // Firefox v55
    if (event.originalTarget) {
      error = error.originalTarget.error;
    }

    let message;

    if (error instanceof Error || error instanceof MediaError) {
      if (error instanceof MediaError && error.code === 4) {
        message = "File not found or format is not supported (webm)";
      } else {
        message = error.message;
      }
    } else {
      message = error.toString();
    }

    if (message !== this.errorMessage) {
      if (error instanceof Error || error instanceof MediaError) {
        console.error(error);
      } else {
        console.log(event);
      }
      if (!this.errorMessage) {
        this.errorMessage = "";
      } else {
        this.errorMessage += "\n";
      }
      this.errorMessage += message;
    }
  }

  onCancelClick() {
    this.activeModal.close();
  }

}
